import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  label {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.color_text};
  }

  .container-filter-input {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;

    select {
      width: 100%;
      height: 40px;
      padding: 8px 40px 8px 12px;
      border: 1px solid ${({ theme }) => theme.input_border};
      border-radius: 4px;
      background: ${({ theme }) => theme.input_background};
      color: ${({ theme }) => theme.color_text};
      font-size: 14px;
      cursor: pointer;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary_color};
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    img {
      position: absolute;
      right: 12px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      opacity: 0.6;
      transition: opacity 0.2s;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
